/**
 * @file Configuration des devises supportées par la plateforme.
 * @module packages.common.config.currencies
 *
 * Source unique de vérité pour toutes les devises disponibles dans l'application.
 * Toute référence à un symbole, un code ou une liste de devises doit passer par ce module.
 */

/**
 * Métadonnées par devise.
 * Clé : code ISO 4217, valeur : configuration d'affichage.
 */
export const CURRENCY_CONFIG = {
  EUR: {symbol: '€', name: 'Euro'},
  CHF: {symbol: 'CHF', name: 'Franc suisse'},
};

/**
 * Liste des codes de devises supportées.
 * Utilisée pour la validation et la génération de listes de sélection.
 */
export const SUPPORTED_CURRENCIES = Object.keys(CURRENCY_CONFIG);

/**
 * Devise par défaut de la plateforme.
 */
export const DEFAULT_CURRENCY = 'EUR';

/**
 * Retourne le symbole d'une devise.
 *
 * @param {string} [currency='EUR'] - Code devise ISO 4217
 * @return {string} Symbole de la devise (ex: '€', 'CHF')
 */
export function getCurrencySymbol(currency) {
  return CURRENCY_CONFIG[currency]?.symbol ?? CURRENCY_CONFIG[DEFAULT_CURRENCY].symbol;
}
